export default "__VITE_ASSET__CWeCh9dk__"